import styled from 'styled-components';
import { useRef } from 'react';

import { showOnMobileAndTabletOnly } from 'styles/utils/responsiveness';
import { useBodyScrollLock } from 'shared/hooks/useBodyScrollLock';
import { useOnRouteChangeComplete } from 'shared/hooks/useOnRouteChangeComplete';
import { SearchBox } from './SearchBox';

interface ISearchPanelMobile {
  closeSearch: () => void;
  suggestedSearches?: any[];
  error?: Error;
}

export const SearchPanelMobile = ({
  closeSearch,
  suggestedSearches,
  error,
}: ISearchPanelMobile) => {
  const searchPanelRef = useRef<HTMLDivElement>();
  useBodyScrollLock(true, searchPanelRef);
  useOnRouteChangeComplete(closeSearch);

  return (
    <SearchPanelMobile.Wrapper ref={searchPanelRef} data-qa="search_panel">
      <SearchBox closeSearch={closeSearch} suggestedSearches={suggestedSearches} error={error} />
    </SearchPanelMobile.Wrapper>
  );
};

SearchPanelMobile.Wrapper = styled.div`
  ${showOnMobileAndTabletOnly`
   position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
  `};
`;

export default SearchPanelMobile;
